<section class="container">
  <!-- Header -->
  <ng-container *ngIf="!addMode && !editMode; else formView">
    <div class="page-header-container">
      <div class="page-title-container">
        <button class="back_icon me-2" mat-icon-button (click)="goBack()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
        <h1 class="page-title" translate>Assignments</h1>
      </div>

      <div *ngIf="filteredAssignments.length > 0">
        <button mat-flat-button color="primary" (click)="addAssignment()" translate>
          <i class="fa-solid fa-plus"></i> Add Assignment
        </button>
      </div>
    </div>

    <!-- Show table if data exists -->
    <table
      *ngIf="filteredAssignments.length > 0"
      mat-table
      [dataSource]="filteredAssignments"
      class="mat-elevation-z2 assignment-table"
    >
      <!-- Title Column -->
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef translate>Assignment Title</th>
        <td mat-cell *matCellDef="let assignment">{{ assignment.title }}</td>
      </ng-container>

      <!-- Deadline Column -->
      <ng-container matColumnDef="deadline">
        <th mat-header-cell *matHeaderCellDef translate>Deadline</th>
        <td mat-cell *matCellDef="let assignment">{{ assignment.deadline }}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef translate>Status</th>
        <td
          mat-cell
          *matCellDef="let assignment"
          [ngClass]="statusClass(assignment.status)"
        >
          <span> {{ assignment.status }} </span>
        </td>
      </ng-container>

      <!-- Pass % Column -->
      <ng-container matColumnDef="passPercent">
        <th mat-header-cell *matHeaderCellDef translate>Pass %</th>
        <td mat-cell *matCellDef="let assignment">
          {{ assignment.passPercent ? assignment.passPercent + "%" : "-" }}
        </td>
      </ng-container>

      <!-- Submission Column -->
      <ng-container matColumnDef="submission">
        <th mat-header-cell *matHeaderCellDef translate>Submission</th>
        <td mat-cell *matCellDef="let assignment">
          {{ assignment.submission }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef translate>Actions</th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            [matMenuTriggerFor]="actionrequest"
            aria-label="Actions"
          >
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </button>

          <mat-menu #actionrequest="matMenu">
            <button mat-menu-item (click)="viewAssignmentsDetails(element.id)" translate>
              <i class="fa-solid fa-eye me-2"></i>View Assignment
            </button>
            <button mat-menu-item (click)="editAssignment(element)" translate>
              <i class="fa-solid fa-pen-to-square me-2"></i> Edit
            </button>
            <!-- <button mat-menu-item (click)="deleteAssignment(element)">
              <i class="fa-solid fa-trash me-2"></i> Delete
            </button> -->
          </mat-menu>
        </td>
      </ng-container>

      <!-- Table Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- Show Add Button in Center when no data -->
    <div *ngIf="filteredAssignments.length === 0" class="no-data-container">
      <p translate>No assignments found for this class.</p>
      <button mat-flat-button color="primary" (click)="addAssignment()" translate>
        <i class="fa-solid fa-plus"></i> Add Assignment
      </button>
    </div>
  </ng-container>
  <ng-template #formView>
    <app-addliststaffassignment
      [assignment]="selectedAssignment"
      (save)="onSaveAssignment($event)"
      (close)="onCloseForm()"
    >
    </app-addliststaffassignment>
  </ng-template>
</section>
